/** Milliseconds for when the listing was last “live” (listedAt → reactivatedAt → createdAt). */
export function listingListedAtMs(pedal) {
  if (!pedal) return 0;
  if (pedal.listedAt) {
    const l = pedal.listedAt;
    if (l && typeof l.toDate === 'function') return l.toDate().getTime();
    const ld = new Date(l);
    return Number.isNaN(ld.getTime()) ? 0 : ld.getTime();
  }
  if (pedal.reactivatedAt) {
    const r = pedal.reactivatedAt;
    if (r && typeof r.toDate === 'function') return r.toDate().getTime();
    const rd = new Date(r);
    return Number.isNaN(rd.getTime()) ? 0 : rd.getTime();
  }
  const c = pedal.createdAt;
  if (c && typeof c.toDate === 'function') return c.toDate().getTime();
  const cd = new Date(c || 0);
  return Number.isNaN(cd.getTime()) ? 0 : cd.getTime();
}

/**
 * Sort by listing date (listed at). Default: newest first (same as legacy want-list matches).
 */
export function sortPedalsByListedAt(pedals, { newestFirst = true } = {}) {
  if (!pedals || pedals.length === 0) return pedals;
  const sign = newestFirst ? -1 : 1;
  return [...pedals].sort(
    (a, b) => sign * (listingListedAtMs(a) - listingListedAtMs(b))
  );
}
